import { clsx } from 'clsx';

import { trackEvent } from '@/services/track-event';

import { useAiSearch } from './AiSearchContext';

/**
 * Thin full-width bar above the global header (Airbnb-style) that lets the
 * renter turn the new AI search on or off. Only shown to the experiment's
 * treatment group on the RV search route. Flipping it fires the Segment
 * 'AI Search Toggled' event; the header reacts by swapping its search bar.
 */
export default function AiSearchTopBar() {
  const { available, enabled, setEnabled } = useAiSearch();

  if (!available) return null;

  const handleToggle = (next: boolean) => {
    setEnabled(next);
    trackEvent({
      event: 'AI Search Toggled',
      enabled: next,
      surface: 'rv_search',
      default_state: false,
    });
  };

  return (
    <div className="flex items-center justify-center w-full px-4 py-2 text-sm text-white bg-gray-900 gap-3">
      <span className="font-semibold">Describe what you’re looking for with the new AI search</span>
      <button
        type="button"
        role="switch"
        aria-checked={enabled}
        aria-label="Toggle AI search"
        onClick={() => handleToggle(!enabled)}
        className={clsx(
          'relative inline-flex items-center w-11 h-6 transition-colors rounded-full',
          enabled ? 'bg-green-500' : 'bg-gray-600',
        )}>
        <span
          className={clsx(
            'inline-block w-5 h-5 transition-transform bg-white rounded-full',
            enabled ? 'translate-x-5' : 'translate-x-1',
          )}
        />
      </button>
      <span className="text-xs text-gray-300">{enabled ? 'On' : 'Off'}</span>
    </div>
  );
}
